if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick(
        {
            prevArrow:'<button type="button" class="slick-prev"><div class="line-btn"></div></button>',
            nextArrow:'<button type="button" class="slick-next"><div class="line-btn"></div></button>'
        }
    );

    $(document).ready(function(){

        $('.media-inquiry-btn').click(function(){
            $('#forms-press-info').fadeToggle();
        });

        $('.close-media-form').click(function(){
            $('#forms-press-info').fadeOut();
        });

        $('.text-modules-wrapper').addClass('animate-fade top');

        $("#start_date").datepicker({
            minDate: 0,
        });
        $("#end_date").datepicker({
            minDate: 0,
        });

    });

    function loadRoomsbyTag(container, selectVal){
        fetch(`${site_url}ajax/functions.php?operation=getRoomsByTag&rooms_tag=`+selectVal,{method: "GET"})
            .then((resp) => resp.json()) // Transform the data into json
            .then((data) => {
                container.innerHTML = data.html; //set data response via fetch in the container
            }).then((data) => {
            $('.images-slides').slick({
                autoplaySpeed: 4000,
                speed: 500,
                fade: true,
                accessibility:false,
                prevArrow:'<button type="button" class="slick-prev"><div class="line-btn"></div></button>',
                nextArrow:'<button type="button" class="slick-next"><div class="line-btn"></div></button>',
                responsive: [
                    {
                        breakpoint: 600,
                        settings: {
                            arrows: false,
                            dots: true
                        }
                    }
                ]
            });
            $('a.fancybox').fancybox();
        });
    }

    const rooms_container = document.querySelector('.rooms-container');

    if (document.getElementsByClassName('menu-rooms').length >= 1 ){
        loadRoomsbyTag(rooms_container,'all');
    }

    const special_links = document.querySelectorAll('.rooms-nav button'); 
    const specials_lengt = special_links.length;
    for(let i = 0; i < specials_lengt; i++){
        special_links[i].addEventListener('click', function(){
            const this_tag = this.dataset.tag;
            for(let l = 0; l < specials_lengt; l++){
                special_links[l].classList.remove('active');
                special_links[l].setAttribute("aria-selected", "false");
            }
            this.classList.add('active');
            this.setAttribute("aria-selected", "true");
            loadRoomsbyTag(rooms_container,this_tag);
        })
    }

    const special_selec = document.querySelectorAll('#rooms-nav');
    const special_lengt = special_selec.length;
    for(let i = 0; i < special_lengt; i++){
        special_selec[i].addEventListener('change', function(){
            const this_tag = this.value;
            loadRoomsbyTag(rooms_container,this_tag);
        })
    }

})();